import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { supabase } from '@/lib/supabase/client'
import { useAuthStore, type AuthUser } from '../stores/use-auth-store'

export function ProtectedRoute() {
  const { user, setUser } = useAuthStore()
  const [initializing, setInitializing] = useState(!user)

  useEffect(() => {
    supabase.auth.getSession().then(async ({ data }) => {
      if (data.session?.user) {
        const supaUser = data.session.user
        // Load profile for full_name + is_super_user
        const { data: profile } = await supabase
          .from('user_profiles')
          .select('full_name, is_super_user')
          .eq('id', supaUser.id)
          .maybeSingle()

        setUser({
          id: supaUser.id,
          email: supaUser.email ?? '',
          name: profile?.full_name ?? (supaUser.user_metadata?.full_name as string | undefined) ?? undefined,
          isSuperUser: profile?.is_super_user ?? false,
        })
      } else if (!data.session) {
        setUser(null)
      }
      setInitializing(false)
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        setUser(null)
      }
    })

    return () => subscription.unsubscribe()
  }, [setUser])

  if (initializing) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />
  }

  return <Outlet />
}
